<template>
  <div
    id="devices-view"
    class="pa-4"
  >
    <view-page-header :show-team-select="false" />

    <portal
      key="adminDevicesPortal"
      to="headerFilters"
    >
      <v-row align="center">
        <v-col cols="auto">
          <v-btn
            color="primary"
            class="text-none"
            href="https://api.asi.swiss/home/"
            target="_blank"
            outlined
          >
            {{ $t('button.activate_fieldwiz') }}
            <v-icon
              right
              small
            >
              far fa-arrow-up-right-from-square
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn
            key="syncDevices"
            color="primary"
            class="text-none"
            outlined
            :loading="syncingActiveDevices"
            @click="syncDevices()"
          >
            {{ $t('button.sync_active_devices') }}
            <v-icon
              right
              small
            >
              far fa-sync
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </portal>

    <section>
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <div class="subtitle-2">
            {{ $t("table_title.list_of_all_devices") }}
          </div>
          <!--          <div class="d-flex align-center">-->
          <!--            <span class="mr-3 subtitle-2">Filter Devices</span>-->
          <!--            <v-btn icon>-->
          <!--              <v-icon>-->
          <!--                fal fa-filter-->
          <!--              </v-icon>-->
          <!--            </v-btn>-->
          <!--          </div>-->
        </v-card-title>
        <v-card-text class="pa-0">
          <v-data-table
            :headers="headers"
            :loading="devices.loading"
            :items="devices.data"
            hide-default-footer
            disable-pagination
            sort-by="human_id"
            must-sort
          >
            <!--<editor-fold desc="ITEM SLOT">-->
            <template v-slot:item="{ item: device }">
              <tr>
                <td>{{ device.human_id }}</td>
                <td>
                  {{ device.serial_number }}
                </td>
                <td>
                  {{ device.device_name }}
                </td>
                <td>
                  <v-chip
                    v-if="device.status"
                    label
                    :color="deviceStatuses[device.status].color"
                    dark
                    small
                  >
                    {{ deviceStatuses[device.status].text }}
                  </v-chip>
                </td>
                <td>
                  <span v-if="device.players && device.players.length > 0">
                    {{ device.players.map(p => p.name).join(', ') }}
                  </span>
                  <span
                    v-else
                    class="grey--text"
                  >
                    N/A
                  </span>
                </td>
                <td>
                  {{ $dayjs(device.created_at).format(getDateTimeFormatForUser('ll HH:mm:ss')) }}
                </td>
                <td>
                  <div class="d-flex">
                    <v-btn
                      icon
                      class="mr-2"
                      @click="editDevice(device)"
                    >
                      <v-icon small>
                        fal fa-edit
                      </v-icon>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>
            <!--</editor-fold>-->
            <!--</editor-fold>-->
          </v-data-table>
        </v-card-text>
      </v-card>
    </section>
  </div>
</template>

<script>
import ViewPageHeader from '@/components/ViewPageHeader'
import { EventBus } from '@/plugins/bus'
import { DeviceApiService } from '@/data/services/DeviceApiService'
import { DeviceStatuses } from '@/data/models/Device'
import i18n from '@/plugins/i18n'
import { getDateTimeFormatForUser } from '@/utils/helpers'

export default {
  name: 'AdminDevicesView',
  components: { ViewPageHeader },
  data: () => ({
    devices: {
      data: [],
      loading: false
    },
    syncingActiveDevices: false
  }),
  created() {
    this.deviceStatuses = DeviceStatuses

    this.fetchDevicesList()

    this.headers = [
      { value: 'human_id', text: i18n.t('table_headers.admin_devices.custom_name') },
      { value: 'serial_number', text: i18n.t('table_headers.admin_devices.serial_number'), sortable: false },
      { value: 'device_name', text: i18n.t('table_headers.admin_devices.device_name') },
      { value: 'status', text: i18n.t('table_headers.admin_devices.fieldwiz_status') },
      { value: 'player_id', text: i18n.t('table_headers.admin_devices.associated_player') },
      { value: 'created_at', text: i18n.t('table_headers.admin_devices.added') },
      { width: '1%', align: 'end', text: '', sortable: false }
    ]

    EventBus.$on(this.$events.DEVICE_CREATED, () => this.fetchDevicesList())
    EventBus.$on(this.$events.DEVICE_UPDATED, () => this.fetchDevicesList())
    EventBus.$on(this.$events.DEVICE_DELETED, () => this.fetchDevicesList())
  },
  methods: {
    getDateTimeFormatForUser,
    async fetchDevicesList() {
      try {
        this.devices.loading = true

        const resp = await DeviceApiService.getAll()

        this.devices.data = resp.data
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.loading_data.error'),
          color: 'error'
        })
        throw e
      } finally {
        this.devices.loading = false
      }
    },
    editDevice(device) {
      EventBus.$emit(this.$events.EDIT_DEVICE, device)
    },
    async syncDevices() {
      try {
        this.syncingActiveDevices = true

        await DeviceApiService.fieldwizSyncDevices()

        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.devices_sync.success'),
          color: 'success'
        })

        this.fetchDevicesList()
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.devices_sync.error'),
          color: 'error'
        })
        throw e
      } finally {
        this.syncingActiveDevices = false
      }
    }
  }
}
</script>
